
import _ from '@lodash';
import { Button, Icon, IconButton, withStyles } from '@material-ui/core';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import * as Helpers from 'app/Core/Helpers';
import history from 'history.js';
import React from 'react';
import clsx from "clsx";
import connect from 'react-redux/es/connect/connect';
import { withRouter } from 'react-router-dom';
import XAPPTooltip from '../Tooltip/XAPPTooltip';

const styles = theme => ({
    button: {
        textTransform: 'initial',
        whiteSpace: "nowrap",
        color: theme.palette.text.secondary,
        display: "none",
        "@media (min-width: 1280px)": {
            display: "block"
        }
    },
    icon: {
        padding: 6,
        color: theme.palette.text.secondary,
        display: "block",
        "@media (min-width: 1280px)": {
            display: "none"
        }
    }
});

class Favorito extends XAPPComponent {

    getFavorito = (_ANavigation = null) => {
        let AArray = [];

        if (!_.isNull(_ANavigation)) {
            _ANavigation.children.forEach(function (item) {
                if (item.type === "item" && item.favorito !== 0 && _.findIndex(AArray, { id: item.id }) === -1) {
                    AArray.push(item);
                }
                else if (item.type === "collapse") {
                    AArray = AArray.concat(this.getFavorito(item));
                }
            }.bind(this));
        }

        return JSON.parse(Helpers.ReplaceAll(JSON.stringify(AArray), "<##DATA##>", Date.now()));
    }

    render() {
        const { navigation = null, empresa, classes, fullscreen } = this.props;
        let AFavoritos = [];
        if (!_.isNull(navigation)) {
            AFavoritos = this.getFavorito(navigation[empresa]);
            AFavoritos = AFavoritos.sort(function (a, b) {
                if (a.favorito > b.favorito) {
                    return 1;
                }
                if (a.favorito < b.favorito) {
                    return -1;
                }
                return 0;
            });
        }
        return (
            <div className="flex flex-row pl-4">
                {_.uniqBy(AFavoritos, 'id').map(item => {
                    return (
                        <React.Fragment key={"favorito_" + item.id}>
                            <XAPPTooltip
                                title={item.title}
                                placement={"bottom"}
                            >
                                <IconButton
                                    className={clsx(classes.icon, !fullscreen && "block")}
                                    onClick={() => history.push(item.url)}
                                >
                                    <Icon className="text-20">{item.icon}</Icon>
                                </IconButton>
                            </XAPPTooltip>
                            <Button
                                className={clsx(classes.button, !fullscreen && "hidden")}
                                onClick={() => history.push(item.url)}
                                color="secondary"
                            >
                                {item.title}
                            </Button>
                        </React.Fragment>
                    );
                })}
            </div>
        );
    };
}

function mapStateToProps({ fuse, PainelFixo }) {
    return {
        navigation: fuse.navigation.navigation,
        empresa: fuse.navigation.empresa,
        fullscreen: _.isNull(PainelFixo?.conteudo),
    }
}

Favorito.defaultProps = {
    layout: "vertical"
};

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps)(Favorito)));
